import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { IModifiersContext, ModifiersContext } from '../../modifiersState/modifiersContext';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IModifiersContext>(ModifiersContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteModifier"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteModifierSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingModifier"
			/>
		</div>
	);
};

export default ModalWindows;
